<template>
    <div v-loading.fullscreen.lock="loading">
        <banner></banner>
        <div class="package" id="largeFlow">
            <p class="title">{{$t('pkgList.title')}}</p>
            <p class="titleTip">{{$t('pkgList.title_tip')}}</p>
            <!-- <p class="toFreeCard">{{$t('pkgList.top_tip')}}<router-link tag="a" :to="{name:'fillInfo'}">{{$t('btn.receive')}}</router-link></p> -->
            <ul class="packageList">
                <li class="clearfix">
                    <img class="hot" src="../../static/images/icon-hot.png" alt="">
                    <div class="title" data-duration="有效期：1年">
                        <p class="price">HK$<span>{{pkgList[0].price}}</span></p>
                        <p><s>HK$ {{pkgList[0].oldprice}}</s></p>
                    </div>
                    <div class="mid">
                        <img src="../../static/images/packageIcon-1.png" alt=""><span><i>{{pkgList[0].flow}}GB</i><br/>{{pkgList[0].des[0]}}</span>
                    </div>
                    <div class="mid">
                        <img src="../../static/images/packageIcon-2.png" alt=""><span><i>{{pkgList[0].time_hk}}min</i><br/>{{pkgList[0].des[1]}}</span>
                    </div>
                    <div class="mid">
                        <img src="../../static/images/packageIcon-3.png" alt=""><span><i>{{pkgList[0].time_ch}}min</i><br/>{{pkgList[0].des[2]}}</span>
                    </div>
                    <div class="mid">
                        <a href="javascript:void(0)" class="btn" @click="buyPkg('200000056')">{{$t('btn.order')}}</a>
                    </div>
                </li>
                <li class="clearfix">
                    <div class="title" data-duration="有效期：1年">
                        <p class="price">HK$<span>{{pkgList[1].price}}</span></p>
                        <p><s>HK$ {{pkgList[1].oldprice}}</s></p>
                    </div>
                    <div class="mid">
                        <img src="../../static/images/packageIcon-1.png" alt=""><span><i>{{pkgList[1].flow}}GB</i><br/>{{pkgList[1].des[0]}}</span>
                    </div>
                    <div class="mid">
                        <img src="../../static/images/packageIcon-2.png" alt=""><span><i>{{pkgList[1].time_hk}}min</i><br/>{{pkgList[1].des[1]}}</span>
                    </div>
                    <div class="mid">
                        <img src="../../static/images/packageIcon-3.png" alt=""><span><i>{{pkgList[1].time_ch}}min</i><br/>{{pkgList[1].des[2]}}</span>
                    </div>
                    <div class="mid">
                        <a href="javascript:void(0)" class="btn" @click="buyPkg('200000057')">{{$t('btn.order')}}</a>
                    </div>
                </li>
            </ul>
            <p class="listTip">{{$t('getCardSuccess.listTip')}}</p>
        </div>
        <div class="tranPkg">
            <div class="topPic"></div>
            <div class="tranPkgCon" id="tranPkg">
                <p class="title">{{$t('pkgList.tranPkg.title')}}</p>
                <p class="titleTip">{{$t('pkgList.tranPkg.title_tip')}}</p>
                <p class="talk">
                    <img src="../../static/images/icon-talk.png" alt=""><span><i>{{$t('pkgList.tranPkg.top')}}</i><br/>{{$t('pkgList.tranPkg.top_ans')}}</span>
                </p>
                <div class="tranPkgList">
                    <div class="changeList">
                        <span v-for="(item,index) in packageTitle" :class="index==indexSelect?'cur':''" @click="changePkg(index)">{{item.name}}</span>
                    </div>
                    <p v-if="indexSelect=='0'" class="advBanner"><a href="javascript:void(0)" @click="showAward"><img src="../../static/images/adv-banner.png" alt="" v-if="$i18n.locale == 'zh'"><img src="../../static/images/adv-banner-hk.png" alt="" v-if="$i18n.locale == 'hk'"></a></p>
                    <p v-else class="advBanner"><img src="../../static/images/adv-banner-1.jpg" alt="" v-if="$i18n.locale == 'zh'"><img src="../../static/images/adv-banner-1-hk.jpg" alt="" v-if="$i18n.locale == 'hk'"></p>
                    <div class="stuTip">
                        <p v-if="indexSelect=='0'"><span>[免]</span> {{$t('pkgList.stuTip1')}}</p>
                        <p v-if="indexSelect=='0'"><span>[送]</span> {{$t('pkgList.stuTip2')}}</p>
                        <p class="clearfix">
                            <m v-if="indexSelect=='0'"><span>[送]</span> {{$t('pkgList.stuTip3')}}</m>
                            <m class="monthTip">{{$t('pkgList.period')}}<i>{{$i18n.locale == 'zh'?'12个月':'12個月'}}</i></m>
                        </p>
                    </div>
                    <!-- <ul class="listCon" v-show="pkgSelected">
                        <li class="clearfix">
                            <img class="hot" src="../../static/images/icon-hot-2.png" alt="">
                            <div class="price">
                                <span class="icon">羽量级</span>
                                <p>HK $<span>58</span> <s>HK $78</s></p>
                            </div>
                            <div class="mid">
                                <p>本地通话<span>1000分钟</span></p>
                                <p>本地数据<span>2GB（4G LTE）+其后无限</span></p>
                            </div>
                            <div class="last">
                                <a href="javascript:void(0)" class="btn">立即转换</a>
                            </div>
                        </li>
                    </ul> -->
                    <ul v-show="index==indexSelect" class="listCon" v-for="(item,index) in packageList">
                        <li v-for="(item,index) in item.plan_list" class="clearfix">
                            <img v-if="item.plan_id=='232'||item.plan_id=='185'" class="hot" src="../../static/images/icon-hot-2.png" alt="">
                            <div class="price">
                                <span class="icon">{{$i18n.locale == 'zh'?item.img_url:item.img_url_hk}}</span>
                                <p>HK $<span>{{item.current_price}}</span> <s>HK ${{item.original_price}}</s></p>
                            </div>
                            <div class="mid" v-html="$i18n.locale=='zh'?item.servicecontent:item.servicecontent_hk"></div>
                            <div class="last">
                                <a href="javascript:void(0)" target="_blank" @click="ifPostPay(item.plan_id)" class="btn">{{$t('btn.trans')}}</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="footer">{{$t('footer')}}</div>
        </div>
        <!--赏你赏他弹窗-->
        <pop class="info_award" :is-pop-show.sync="isShowAward" sureBtn_zh="我知道了" sureBtn_hk="我知道了" :is-show-cancel="false" @on-sure="sureAward">
	    	<div slot="xw-pop-modal-body" class="xw-pop-modal-body">
	    		<h3>{{$t('awardInfo.title')}}</h3>
	    		<div class="words">
		    		<p class="title">{{$t('awardInfo.title_tip1')}}</p>
		    		<p>{{$t('awardInfo.tip1')}}</p>
		    		<p class="title">{{$t('awardInfo.title_tip2')}}</p>
		    		<p>{{$t('awardInfo.tip2')}}</p>
		    		<p>{{$t('awardInfo.time')}}</p>
	    		</div>
	    	</div>
	    </pop>
    </div>
</template>

<script>
    import banner from '@/components/banner'
    import {getTransformPlans} from '@/api/api'
    import pop from "@/components/pop"
    import axios from 'axios'
    axios.defaults.withCredentials = true 
    export default{
        components:{
            banner,
            pop
        },
        data(){
            return{
                loading:false,
                indexSelect:0,
                pkgSelected:true,
                packageList_zh:[],
                packageList_en:[],
                packageList:[],
                isShowAward: false,//弹窗,
                usertype:'',
                pkgUrl:'https://www.ctexcel.com.hk/toConverPlanNew?planid=',
            }
        },
        methods: {
            changePkg(index){
                this.indexSelect = index;
                if(index == '0'){
                    this.pkgSelected = true;
                }else{
                    this.pkgSelected = false;
                }
            },
            buyPkg (bundlecode) {
		  		this.$router.push({name: 'inputIccid',query: {'bundlecode': bundlecode}})
		  	},
		  	showAward () {//显示弹窗
		  		this.isShowAward = true
		  	},
		  	sureAward () {//关闭弹窗
		  		this.isShowAward = false
            },
            ifPostPay(planId){
                this.loading=true;
                //测试接口https://dev.ctexcel.com.hk/ctghk/validateLoginType
                axios.post('https://www.ctexcel.com.hk/validateLoginType').then(res=>{
                    console.log(res.data.usertype);
                    this.loading=false;
                    if(res.data.usertype=='1'){
                        //window.location.href='https://dev.ctexcel.com.hk/ctghk/toConverPlanNew?planid='+planId
                        window.location.href='https://www.ctexcel.com.hk/toConverPlanNew?planid='+planId
                    }else if(res.data.usertype=='2'){
                        var safe = this;
                        this.$msgbox({
                            title: safe.$i18n.locale=='zh'?'提示':'提示',
                            message:safe.$i18n.locale=='zh'?'您当前已是月费计划用户':'您當前已是月費計劃用戶',
                            showCancelButton: false,
                            confirmButtonClass: 'center',
                            confirmButtonText: safe.$i18n.locale=='zh'?'确定':'確定',
                            callback: action => {
                                
                            }
                        })
                        return;
                    }
                })
            }
        },
        mounted() {
            getTransformPlans().then(res=>{
                this.packageList = res.dataList;
                console.log(this.packageList);
            }).catch(error=>{
                console.log(error);
            })
        },
        computed:{
            packageTitle(){
                return [
                    {name:this.$i18n.locale == 'zh'?'大学生本地流动通讯计划':'大學生本地流動通訊計劃'},
                    {name:this.$i18n.locale == 'zh'?'高速本地流动通讯计划':'高速本地流動通訊計劃'}
                ]
            },
            pkgList () {//套餐详细信息
		  		return this.$i18n.locale == 'zh'?require('@/common/json/pkgList'): require('@/common/json/pkgList_hk')
		  	}
        }
    }
</script>

<style scoped>
    .footer{ text-align: center; color:#999; font-size: 12px; line-height: 60px; margin-top: 50px;}
    @media (max-width:767px) {
        .footer{ margin-top: 0;}
    }
</style>


// WEBPACK FOOTER //
// src/pages/pkgList.vue